import { Component, OnInit, ViewChildren, QueryList, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { MenuItem } from 'src/app/beans/menu/menu-item/menu-item.bean';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { MenuConf } from 'src/app/beans/menu/menu-conf/menu-conf.bean';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { Router } from '@angular/router';
import { MenuTitle } from 'src/app/enums/menu/menu-title.enum';
import { AuthLevel } from 'src/app/enums/auth/auth.enum';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { version } from 'src/environments/version';
import { I } from '@angular/cdk/keycodes';

export interface Section {
  name: string;
  updated: Date;
}

@Component({
  selector: 'main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit
{
  @Input()  menuConf  : MenuConf

  private menuItems: QueryList<MenuItemComponent>

  @ViewChildren(MenuItemComponent) set _menuItems(menuItems: QueryList<MenuItemComponent>){
    this.menuItems = menuItems
  }

  @HostListener('window:popstate', ['$event'])
  async onPopState()
  {
    await this._utils.time().delay(100)

    let path = this._router.url.replace("/", "")

    this.selectElement(path)
  }

  @Output('clicked') clicked: EventEmitter<boolean> = new EventEmitter<boolean>()

  private selectedItem: MenuItemComponent

  items : MenuItem[] = [
    {
      id    :   RoutingPages.DASHBOARD,
      icon  :  "home"                 ,
      title :   MenuTitle   .DASHBOARD,
      ref   :   RoutingPages.DASHBOARD,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ]
    },
    {
      id          :   RoutingPages.ORGANIZATION_DETAIL,
      icon        :  "location_city"                  ,
      title       :   MenuTitle   .ORGANIZATION       ,
      ref         :   RoutingPages.ORGANIZATION_DETAIL,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER
      ]
    },
    {
      id    :   RoutingPages.SITE_DETAIL ,
      icon  :  "store"                   ,
      title :   MenuTitle   .SITE        ,
      ref   :   RoutingPages.SITE_DETAIL ,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ]
    },
    {
      id    : RoutingPages.MANAGEMENT_SERVICE,
      icon  : "layers"                       ,
      title : MenuTitle.MANAGEMENT_SERVICE   ,
      ref   : RoutingPages.MANAGEMENT_SERVICE,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ]
    },
    {
      id    : RoutingPages.DEVICE,
      icon  : "phonelink_setup"  ,
      title : MenuTitle   .DEVICE,
      ref   : RoutingPages.DEVICE,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ],
      children:
      [
        {
          id    : RoutingPages.MANAGEMENT_DEVICE,
          icon  : "settings_remote"             ,
          title : MenuTitle.MANAGEMENT_DEVICE   ,
          ref   : RoutingPages.MANAGEMENT_DEVICE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
        {
          id    : RoutingPages.DEVICE_SERVICE ,
          icon  : "event_seat"                ,
          title : MenuTitle   .DEVICE_SERVICE ,
          ref   : RoutingPages.DEVICE_SERVICE ,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
        {
          id    : RoutingPages.LICENCE,
          icon  : "receipt_long"             ,
          title : MenuTitle.LICENCE   ,
          ref   : RoutingPages.LICENCE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
      ]
    },
    {
      id    : RoutingPages.TIMESTABLE,
      icon  : "schedule"             ,
      title : MenuTitle   .TIMESTABLE,
      ref   : RoutingPages.TIMESTABLE,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ],
      children:
      [
        {
          id    : RoutingPages.TIMESTABLE_DEVICE,
          icon  : "more_time"                   ,
          title : MenuTitle.TIMESTABLE_DEVICE   ,
          ref   : RoutingPages.TIMESTABLE_DEVICE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
        {
          id    : RoutingPages.TIMESTABLE_SERVICE,
          icon  : "more_time"                    ,
          title : MenuTitle.TIMESTABLE_SERVICE   ,
          ref   : RoutingPages.TIMESTABLE_SERVICE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
        {
          id    : RoutingPages.SLOTAUTOMATE,
          icon  : "more_time"                    ,
          title : MenuTitle.SLOTAUTOMATE   ,
          ref   : RoutingPages.SLOTAUTOMATE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        }
      ]
    },
    {
      id    : RoutingPages.MANAGEMENT_MESSAGE,
      icon  : "chat"                         ,
      title : MenuTitle.MANAGEMENT_MESSAGE   ,
      ref   : RoutingPages.MANAGEMENT_MESSAGE,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ]
    },
    {
      id    : RoutingPages.MANAGEMENT_BOOKING ,
      icon  : "book_online"                   ,
      title : MenuTitle.MANAGEMENT_BOOKING    ,
      ref   : RoutingPages.MANAGEMENT_BOOKING ,
      authorized  :   [
        AuthLevel.ORG_MANAGER        ,
        AuthLevel.SITE_MANAGER       ,
        AuthLevel.CALLCENTER_OPERATOR
      ]
    },
    {
      id    : RoutingPages.OPERATOR,
      icon  : "engineering"        ,
      title : MenuTitle   .OPERATOR,
      ref   : RoutingPages.OPERATOR,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ],
      children:
      [
        {
          id    : RoutingPages.MANAGEMENT_OPERATOR,
          icon  : "group"                         ,
          title : MenuTitle.MANAGEMENT_OPERATOR   ,
          ref   : RoutingPages.MANAGEMENT_OPERATOR,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER
          ]
        },
        {
          id    : RoutingPages.OPERATOR_COUNTER,
          icon  : "recent_actors"              ,
          title : MenuTitle   .OPERATOR_COUNTER,
          ref   : RoutingPages.OPERATOR_COUNTER,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER
          ]
        },
        {
          id    : RoutingPages.ASSIGN_OPERATOR,
          icon  : "group_add"                 ,
          title : MenuTitle   .ASSIGN_OPERATOR,
          ref   : RoutingPages.ASSIGN_OPERATOR,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
      ]
    },
    {
      id    :   RoutingPages.STATISTIC,
      icon  :  "insert_chart_outlined",
      title :   MenuTitle   .STATISTIC,
      ref   :   RoutingPages.STATISTIC,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ]
    },
    /* {
      id    : RoutingPages.MEDIA,
      icon  : "perm_media"        ,
      title : MenuTitle   .MEDIA,
      ref   : RoutingPages.MEDIA,
      authorized  :   [
        AuthLevel.HUB_MANAGER,
        AuthLevel.ORG_MANAGER,
        AuthLevel.SITE_MANAGER
      ],
      children:
      [
        {
          id    : RoutingPages.MEDIA_ORGANIZATION,
          icon  : "location_city"                         ,
          title : MenuTitle.MEDIA_ORG   ,
          ref   : RoutingPages.MEDIA_ORGANIZATION,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER
          ]
        },
        {
          id    : RoutingPages.MEDIA_SITE,
          icon  : "store"                         ,
          title : MenuTitle.MEDIA_SITE   ,
          ref   : RoutingPages.MEDIA_SITE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        },
        {
          id    : RoutingPages.MEDIA_SERVICE,
          icon  : "layers"                         ,
          title : MenuTitle.MEDIA_SERVICE   ,
          ref   : RoutingPages.MEDIA_SERVICE,
          authorized  :   [
            AuthLevel.HUB_MANAGER,
            AuthLevel.ORG_MANAGER,
            AuthLevel.SITE_MANAGER
          ]
        }
      ]
    } */
  ]

  constructor
  (
    private _session: SessionManager,
    private _router : Router,
    private _utils  : UtilsManager
  ) {}

  ngOnInit(): void {}

  selectElement(id: string)
  {
    if (!this.menuItems ) return

    const item = this.menuItems.find (el => el.checkIfHasItem(id) != undefined )


    if (item) {
      if (!item.canAccess( item.item.authorized )) return

      const newItem = item.checkIfHasItem(id)
      if (!newItem.canAccess( newItem.item.authorized )) return

      if (this.selectedItem) this.selectedItem.unselectItem()

      this.selectedItem = newItem
      if (this.selectedItem) {

        this.selectedItem.selectItem()
        this.clicked.emit(true)

        if (this.menuConf){
          this.menuConf.item = this.selectedItem.item
          this._session.menu().set( this.menuConf )
        }
        this._router.navigate([this.selectedItem.item.ref])
      }
    }
  }

  checkAuth (id: string)
  {
    if (!this.menuItems ) return

    const item = this.menuItems.find (el => el.checkIfHasItem(id) != undefined )

    if (item) {
      const itemComponent = item.checkIfHasItem(id)
      if (itemComponent)
        return itemComponent.canAccess( itemComponent.item.authorized )
    }

    return false
  }

  itemClicked(item: MenuItem)
  {
    this.selectElement(item.id)
  }

  getCurrentVersion()
  {
    return version.value
  }
}
